module.exports = __webpack_public_path__ + "img/slide15.01935e67.png";